import { store } from "store";

export class Token {
  static async getAccessToken() {
    return store.getState().admin.token;
  }
}
